import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarNominas } from '../../actions/nominas';
import { buscarSucursales } from '../../actions/sucursales';
import { buscarEmpleados } from '../../actions/empleados';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import FiltrosNomina from './FiltrosNomina';

const formatNombre = (persona) => persona
    ? `${persona.nombre || ''} ${persona.apellido_paterno || ''} ${persona.apellido_materno || ''}`.trim()
    : '-';

const formatFecha = (fecha) => fecha
    ? new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
    : '-';

const filtrosVacios = {
    sucursal: null,
    responsable: null,
    status: null,
    fecha_inicio: null,
    fecha_fin: null
};

const Nominas = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const listado = useSelector(state => state.nominas.listado);

    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarNominas(filtrosVacios));
        dispatch(buscarSucursales());
        dispatch(buscarEmpleados());
        dispatch(editarBreadcrumb([
            { nombre: 'Nóminas', path: '/nominas', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarNominas(nuevosFiltros));
    };

    const filtrosActivos = [
        filtros.sucursal,
        filtros.responsable,
        filtros.status !== null,
        filtros.fecha_inicio,
        filtros.fecha_fin
    ].filter(Boolean).length;

    const columns = [
        {
            name: 'Responsable',
            sortable: true,
            selector: row => formatNombre(row.responsable),
            grow: 2
        },
        {
            name: 'Sucursal',
            selector: row => formatNombre(row.sucursal),
            grow: 1.5
        },
        {
            name: 'Fecha inicio',
            sortable: true,
            sortFunction: (a, b) => new Date(a.fecha_inicio) - new Date(b.fecha_inicio),
            selector: row => formatFecha(row.fecha_inicio)
        },
        {
            name: 'Fecha fin',
            sortable: true,
            selector: row => formatFecha(row.fecha_fin)
        },
        {
            name: 'Empleados',
            sortable: true,
            selector: row => row.total_empleados ?? '-'
        },
        {
            name: 'Status',
            sortable: true,
            cell: row => (
                <span className={`badge ${row.status === true ? 'bg-success' : 'bg-warning text-dark'}`}>
                    {row.status === true ? 'Finalizada' : 'En proceso'}
                </span>
            )
        },
        {
            name: 'Acciones',
            cell: row => (
                <Link className="btn btn-sm btn-info" to={`/nominas/editar/${row._id}`}>
                    <i className="fas fa-eye"></i>
                </Link>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-4 d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Nóminas</h4>
                <div className="d-flex gap-3">
                    <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                        <i className="fas fa-filter me-1"></i> Filtros
                        {filtrosActivos > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                                {filtrosActivos}
                            </span>
                        )}
                    </button>
                    <button className="btn btn-primary" onClick={() => navigate('/nominas/nuevo')}>
                        <i className="fas fa-plus me-1"></i> Nueva nómina
                    </button>
                </div>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    defaultSortFieldId={2}
                    defaultSortAsc={false}
                    noDataComponent="No hay nóminas registradas"
                />
            </div>

            <FiltrosNomina
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />
        </div>
    );
};

export default Nominas;
